module.exports = __webpack_public_path__ + "static/media/Tamalchino.e2c089a4.jpg";